import React, { useMemo } from "react";
import Plyr from "plyr-react";
import "plyr/dist/plyr.css";

const VideoPlayer = ({ preUrl, fileId }) => {
  const videoSource = useMemo(
    () => ({
      type: "video",
      sources: [
        {
          src: preUrl,
          type: "video/mp4",
        },
      ],
    }),
    [preUrl]
  );

  return (
    <div
      style={{
        height: "calc(100vh - 64px)",
        display: "flex",
        // justifyContent: "center",
        // alignItems: "center",
      }}
    >
      <Plyr
        key={fileId || preUrl}
        type="video"
        source={videoSource}
        controls={true}
      />
    </div>
  );
};

export default VideoPlayer;
